<template>
	<div class="card detailCard flex flex-col rounded-sm shadow-lg">
		<loading-spinner v-if="loading" />
		<template v-else>
			<slot></slot>
		</template>
	</div>
</template>

<script>
export default {
	props: {
		loading: Boolean
	}
}
</script>
